module.exports = __webpack_public_path__ + "img/cultureOpen5.56fae8f5.png";